export function altLocale(local: string | undefined) {
  if (typeof local === 'undefined') return '';
  return local === 'en' ? 'fr' : 'en';
}
